import DV from 'ts-data-validator';

import commonConstants    from './common.constants';
import commonInitialState from './common.state';

function commonReducer(state = commonInitialState, action) {
  switch (action.type) {
    case commonConstants.COMMON_GET_PAGE_REQUEST:
      state = {
        ...state,
        loading: true,
      };
      break;

    case commonConstants.COMMON_GET_PAGES_REQUEST:
      state = {
        ...state,
        loading: true,
      };
      break;

    case commonConstants.COMMON_GET_PAGE_SUCCESS:
      state = {
        ...state,
        pages:   [...state.pages].map((page) => {
          if (page.urlKey === action.urlKey) {
            return {
              id:              +action.id || page.id,
              label:           action.label || page.label,
              urlKey:          action.urlKey,
              template:        action.template || page.template,
              isActive:        DV.isBoolean(action.isActive) ? action.isActive : page.isActive,
              isIndexed:       DV.isBoolean(action.isIndexed) ? action.isIndexed : page.isIndexed,
              metaTitle:       action.metaTitle || page.metaTitle,
              metaDescription: action.metaDescription || page.metaDescription,
              metaKeywords:    action.metaKeywords || page.metaKeywords,
              content:         action.content || page.content,
              headImage:       action.headImage || page.headImage,
            };
          } else {
            return { ...page };
          }
        }),
        loading: false,
      };
      for (let i = 0; i < state.pages.length; i++) {
        let page = state.pages[i];

        if (page.urlKey === action.urlKey) {
          state.pages[i] = {
            ...page,
            ...action,
          };
        }
      }
      break;

    case commonConstants.COMMON_GET_PAGES_SUCCESS:
      state = {
        ...state,
        pages:       action.pages || commonInitialState.pages,
        pagesLoaded: true,
        loading:     false,
      };
      break;

    case commonConstants.COMMON_GET_PAGE_FAILURE:
    case commonConstants.COMMON_GET_PAGES_FAILURE:
      state = {
        ...state,
        loading: false,
      };
      break;

    case commonConstants.COMMON_CHANGE_LOCATION:
      const { common } = action;

      state = {
        ...state,
        banners:       common?.banners || [],
        discount:      common?.discount || {},
        notifications: common?.notification || [],
      };
      break;

    default:
      state = { ...state };
  }

  return state;
}

export default commonReducer;